"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Buttons = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        background: theme.palette.common.white,
        display: 'flex',
        flexFlow: 'column',
        padding: theme.spacing(3)
    };
});
const Buttons = (param)=>{
    let { isDisabled, isLoading, onAddOffer } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        "data-testid": getTestId(_models.TestId.ButtonsWrapper),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
            fullWidth: true,
            maxWidth: "500px",
            color: "primary",
            "data-testid": getTestId(_models.TestId.AddOfferButton),
            disabled: isLoading || isDisabled,
            loading: isLoading,
            variant: "contained",
            onClick: onAddOffer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: "buyProductAndGetFreeDelivery"
            })
        })
    });
};
exports.Buttons = Buttons;
